import { createContext } from 'react';

const liveContext = createContext();

export default liveContext;
